import React from "react";
import { sidebarConfig } from "../../config";

export const getSidebarContent = (contentName) => {
  const find = sidebarConfig.content.find((item) => item.name === contentName);
  if (find) {
    const { component: Component } = find;
    return <Component />;
  }
  return null;
};
